export const addPeriodToCache = (field, cache, unavailablePeriodData) => {
  cache.modify({
    fields: {
      [field](existingUnavailablePeriods = []) {
        return [...existingUnavailablePeriods, unavailablePeriodData];
      }
    }
  });
};

export const removePeriodFromCache = (field, cache, unavailablePeriodDataId) => {
  cache.modify({
    fields: {
      [field](existingUnavailablePeriods) {
        return existingUnavailablePeriods.filter(item => item.Id !== unavailablePeriodDataId);
      }
    }
  });
};
